<template>
    <v-list-item link :to="item.route" color="primary" class="sidebar-menu-item" :class="{ 'sidebar-menu-item--nested': nested }" @click.native="emitEvent(item)">
        <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
            <v-list-item-title>{{ item.name }}</v-list-item-title>
        </v-list-item-content>
    </v-list-item>
</template>
<script>
import { eventHub } from "@/main";

export default {
    name: "MenuItem",

    props: {
        item: { type: Object, required: true },
        nested: { type: Boolean, default: false },
    },

    methods: {
        emitEvent(item) {
            if (item.event) {
                eventHub.$emit(item.event)
                return;
            }

            eventHub.$emit('close-menu');
        },
    },
};
</script>
  
<style lang="scss">
.sidebar-menu-item {
    border: 0;
    border-radius: 7px !important;
    margin: 1px 4px;
    min-height: 40px !important;
    padding: 0 10px !important;
    transition: background-color .14s ease;
}

.sidebar-menu-item:hover {
    background: #f6f7f8 !important;
}

.sidebar-menu-item .v-list-item__icon {
    align-self: center;
    margin: 0 11px 0 0 !important;
    min-width: 18px;
}

.sidebar-menu-item .v-icon {
    color: #7b8490;
    font-size: 18px;
}

.sidebar-menu-item .v-list-item__title {
    color: #3f4650;
    font-family: "Plus Jakarta Sans", "Roboto", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif !important;
    font-size: 13px;
    font-weight: 400;
    letter-spacing: 0;
    line-height: 1.25;
    white-space: normal;
}

.sidebar-menu-item--nested {
    border-radius: 7px !important;
    margin: 1px 5px 1px 0;
    min-height: 36px !important;
    padding: 0 10px !important;
}

.sidebar-menu-item--nested .v-list-item__icon {
    margin-right: 10px !important;
    min-width: 16px;
}

.sidebar-menu-item--nested .v-icon {
    font-size: 15px;
}

.sidebar-menu-item--nested .v-list-item__title {
    color: #555d67;
    font-size: 12.5px;
    font-weight: 400;
}

.sidebar-menu-item.v-list-item--active {
    background: #f0f1f2 !important;
    box-shadow: none;
}

.sidebar-menu-item.v-list-item--active .v-icon,
.sidebar-menu-item.v-list-item--active .v-list-item__title {
    color: #20262e !important;
    font-weight: 500;
}
</style>
